module.exports = __webpack_public_path__ + "img/轮播4.1eb29ac7.png";